export const DATE_FORMAT = 'YYYY-MM-DD'
export const INPUT_DATE_FORMAT = 'DD-MM-YYYY'
export const DISPLAY_DATE_FORMAT = 'DD/MM/YYYY'
export const LONG_DATE_FORMAT = 'dddd, D MMMM YYYY'
export const SEARCH_DATE_FORMAT = 'D MMM'
export const TIME_FORMAT = 'H:mm'
export const SHORT_DAY_FORMAT = 'ddd'
export const LONG_DAY_FORMAT = 'dddd'
export const DEAL_DAY_FORMAT = 'D MMM YYYY'
export const LONG_DATE_TIME_FORMAT = 'D MMMM YYYY, h:m a'
export const DATE_WITH_LONG_MONTH = 'DD-MMMM-YYYY'
